<template>
  <q-layout>
    <q-header elevated class="bg-secondary">
      <q-bar class="q-my-md bg-secondary">
        <q-btn flat @click="drawer = !drawer" size="md" color="white" round dense icon="menu" />
        <div class="col text-center">
          <q-icon 
            size="130px"
            name="img:/assets/qrperk-darkbg.svg"
            spinner-color="white"
          />
        </div>
      </q-bar>
    </q-header>
    <drawer :drawer="drawer" @hide="drawer = false" />
    <!--<div id="nav">
      <div class="navigation-pills">
        <div class="row justify-end q-gutter-x-md q-gutter-y-xs">
          <div class="col-md-6" v-if="router.currentRoute.value.name != 'Home'">
            <q-btn to="/" size="md" icon="home" unelevated color="primary"/>
          </div>
          <div class="col-md-6" v-if="router.currentRoute.value.name == 'Home'">
            <q-btn to="/merchant/scan" icon="store" size="md" outline unelevated color="primary"/>
          </div>
        </div>
      </div>
      <router-link to="/">Home</router-link> |
      <router-link to="/merchant/scan">Merchant Scan</router-link>
    </div>-->
    <q-page-container>
      <q-page class="q-pb-lg">
        <router-view />
      </q-page>
    </q-page-container>

    <q-footer class="bg-secondary text-white ">
      <div>
        <q-img
          width="30px"
          src="/assets/icon-app/apple-icon-144x144.png"
          class="absolute"
          style="top: 0; transform: translateY(-50%) translateX(-50%);"
        />
      </div>
      <div class="row justify-center q-gutter-x-sm q-mt-lg">
        <router-link class="text-white text-caption normal-link text-bold" to="/how-it-works">How it works</router-link> 
        <q-icon size="sm" color="grey" name="mdi-circle-small" />
        <router-link class="text-white text-caption normal-link text-bold" to="/merchant">For companies</router-link>
        <q-icon size="sm" color="grey" name="mdi-circle-small" />
        <router-link class="text-white text-caption normal-link text-bold" to="/about">About</router-link>
      </div>
      <div class="row justify-center q-gutter-sm">
        <router-link class="text-white text-caption normal-link" to="/privacy-policy">Privacy Policy</router-link> 
        <q-icon class="" size="sm" color="grey" name="mdi-circle-small" />
        <router-link class="text-white text-caption normal-link" to="/terms-of-use">Terms of use</router-link>
      </div>
      <p class="row justify-center q-gutter-sm">
        <a class="text-white text-caption normal-link text-bold" href="mailto:support@qrperk.com"><q-icon size="xs" name="mdi-email" /> Get in touch</a>
      </p>
      <p class="row justify-center q-gutter-x-md q-my-lg">
        <q-icon size="sm" name="img:/assets/icons/face.svg" />
        <q-icon size="sm" name="img:/assets/icons/twitter.svg" />
        <q-icon size="sm" name="img:/assets/icons/insta.svg" />
      </p>
      <div class="row justify-center text-caption">
        <p class="text-bold q-my-xs">&copy; QrPerk. All rights reserved.</p>
        <p class="q-my-xs">&nbsp;QrPerk is an Australian Company (ABN 14744188009). </p>
      </div>
      <div class="row justify-center text-caption">
        <p class="q-my-xs"> Made with ❤️ in Wollongong, NSW, Australia | Brazil. </p>
      </div>
    </q-footer>
    <!-- <bottom-bar current="home"></bottom-bar> -->

    <!--<img class="q-pa-sm" :src="require('@/assets/logo-white.svg')"  width="250" height="55"/>-->
  </q-layout>
</template>
<script>
import router from '@/router'
import BottomBar from '@/components/BottomBar'
import Drawer from '@/components/Drawer'
import { ref } from '@vue/reactivity'
export default {
  components: { BottomBar, Drawer },
  setup(){
    const drawer = ref(false)
    return {router, drawer}
  }
}

//prevent iphone pinch to zoom
var lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
  var now = (new Date()).getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);
</script>

<style>
.navigation-fabs { display:none; }
@media only screen and (orientation:landscape) and (hover: none) and (pointer: coarse) {
  .navigation-pills { display:none; }
  .navigation-fabs { display:block; }
}
/* Show place card when portrait */
@media only screen and (orientation:portrait) and (hover: none) and (pointer: coarse) {
  .navigation-pills { display:block; }
  .navigation-fabs { display:none; }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 20px 30px;
}

#nav a, a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body{ touch-action:pan-y;}
</style>
